import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import Frame from "./frame"

const StyledContainer = styled.div`
  font-family: ${tokens.font.normal};
  line-height: 1.5;
  color: ${tokens.color.text.base};
  padding: ${1.5 * tokens.size.base}px;
`

// Users can shadow this file to wrap live previews.
// This is useful for applying global styles.
function LivePreviewWrapper({ children }) {
  return (
    <Frame>
      <StyledContainer>{children}</StyledContainer>
    </Frame>
  )
}

LivePreviewWrapper.propTypes = {
  children: PropTypes.node,
}

export default LivePreviewWrapper
